/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                  from 'react';
import PropTypes              from 'prop-types';
import { StyledButtonAnchor } from '../../atoms/StyledButtonAnchor';
import { ThemeProvider }      from 'styled-components';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const ButtonAnchor = ({ exact, to, target, children, onAnchorClick, colour }) => (
    <ThemeProvider theme={{ colour }}>
        <StyledButtonAnchor onClick={onAnchorClick} exact={exact} to={to}
                            target={target}>{children}</StyledButtonAnchor>
    </ThemeProvider>
);

ButtonAnchor.propTypes = {
    colour: PropTypes.string,
    onAnchorClick: PropTypes.func,
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/molecules/ButtonAnchor/index.js